import * as React from 'react';
import './index.scss';

interface Props {
    name: string;
    placeholder?: string;
    setRef?: React.RefObject<HTMLTextAreaElement>;
    onKeyDown?: (e: React.KeyboardEvent) => void;
    onChange?: (e: React.FormEvent<HTMLTextAreaElement>) => void;

}

const Textarea = ({ name, placeholder, onKeyDown, onChange, setRef }: Props) => (
    <textarea className="textarea" ref={setRef} onKeyDown={onKeyDown} onChange={onChange} name={name} placeholder={placeholder}></textarea>
);

export default Textarea;


// WEBPACK FOOTER //
// ./src/components/layout/Textarea/index.tsx